<template>
  <b-modal
    id="suggest_buy_package"
    ref="suggest_buy_package"
    centered
    hide-header
    hide-footer>
    <div class="suggest-modal">
      <div class="image">
        <img src="../../assets/img/calendar.png">
      </div>
      <div class="title">
        GÓI TƯ VẤN PHONG THUỶ THEO NGÀY
      </div>
      <div class="intro">
        Căn cứ vào ngày tháng năm sinh của bạn, hệ thống sẽ tự động phân tích và trả kết quả hàng ngày:
        <div><img src="../../assets/img/basic/tick.png">Hôm nay tốt xấu với bạn thế nào ?</div>
        <div><img src="../../assets/img/basic/tick.png">Nên làm gì, không nên làm gì ?</div>
        <div><img src="../../assets/img/basic/tick.png">Giờ nào được việc, giờ nào thì không?</div>
        <div><b>Bạn dùng thử nhé! Chỉ <span class="text-danger">1.000đ/ngày.</span></b></div>
      </div>

      <div>
        <button
          class="btn btn-success"
          @click="redirectToByPackage">TRẢI NGHIỆM NGAY</button>
      </div>
    </div>
  </b-modal>
</template>

<script>
    export default {
        name: "SuggestBuyPackage",
        methods: {
            redirectToByPackage() {
                this.$router.push('upgrade-account');
            }
        }
    }
</script>

<style lang="scss" scoped>
  .suggest-modal {
    padding: 16px;
    position: relative;

    .image {
      position: absolute;
      margin-left: auto;
      margin-right: auto;
      left: 0;
      right: 0;
      top: -65px;
      border: 3px white solid;
      border-radius: 50%;
      background-color: #017edd;
      padding: 11px;
      width: 90px;
      height: 90px;
    }

    .title {
      font-style: normal;
      font-weight: bold;
      font-size: 16px;
      margin-top: 36px;
      width: 100%;
      text-align: center;
    }

    .intro {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      color: #3B485B;
      margin-top: 18px;
      line-height: 23px;
      text-align: left!important;
      div {
        img {
          margin-right: 5px;
        }
      }
    }

    &:last-child {
      width: 100%;
      text-align: center;

      button {
        margin-top: 16px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/SuggestBuyPackage.vue